import * as zod from 'zod';

// Replay knobs shared by both sources.
const ReplayArgs = zod.object({
  // Move-to-start placement (position-list reference only). Null ⇒ skip
  // move-to-start and anchor wherever the arm is.
  target: zod
    .object({
      positionListID: zod.string(),
      positionListIndex: zod.number().int().nonnegative().optional(),
    })
    .nullable()
    .default(null),
  // OFF ⇒ replay in the recorded world frame; `target`/`pin` are ignored.
  repositionEnabled: zod.boolean().default(false),
  // 'start'/'end' land that frame on the target; 'reference' shifts by
  // targetPose · inv(refWorldPose) (requires a recorded reference frame).
  pin: zod.enum(['start', 'end', 'reference']).default('start'),
  // Trim replay to the contiguous frame run within this many meters of the
  // pin center. Absent/null ⇒ replay everything. `.positive().finite()`
  // rejects 0/NaN at the schema layer.
  sphereRadius: zod.number().positive().finite().nullable().optional(),
  // Playback speed multiplier (1.0 = recorded cadence). Capped at 2× —
  // speed-ups downsample frames so the arm is commanded at speed× the taught
  // velocity, with arm-control-bot's joint limits as the backstop.
  speed: zod.number().min(0.1).max(2).default(1.25),
});

// Skill-driven source (preferred): the runner replays the skill's newest
// linked recording.
const SkillSource = ReplayArgs.extend({
  skillId: zod.string(),
});

// Legacy direct-recording source — no editor UI, still runnable: just the
// recording id plus the shared replay knobs. (A leftover recordingId on a
// skill-driven step is stripped by the SkillSource parse, which is tried
// first.)
const RecordingSource = ReplayArgs.extend({
  recordingId: zod.string(),
});

export default zod.union([SkillSource, RecordingSource]);
